// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Zahllauf, ZahllaufBezeichnung } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useRenameZahllauf(): (
  zahllaufId: string,
  requestBody: ZahllaufBezeichnung
) => Promise<Zahllauf> {
  const getAPI = useGetApi();
  return useCallback(
    async (zahllaufId, requestBody) =>
      (await getAPI()).zahllaeufe.renameZahllauf({ zahllaufId, requestBody }),
    [getAPI]
  );
}
